/**
 * useIsMobile - breakpoint at 768px (matches Home/Agency nav)
 * Use for sidebar collapse, mobile menu bar, and responsive padding.
 */
import { useState, useEffect } from 'react';

const BREAKPOINT = 768;

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth < BREAKPOINT : false
  );

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < BREAKPOINT);
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  return isMobile;
}
